import React from 'react';

import ChildrenPropType from 'lib/CustomPropTypes/children';

function Header(props) {
  const { children } = props;

  return (
    <header className="ontheshow__header">
      { children }
    </header>
  );
}

Header.propTypes = {
  children: ChildrenPropType,
};

Header.defaultProps = {
  children: undefined,
};

export default Header;
